
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f2tcq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $2yWJZ = parcelRequire("2yWJZ");


var $a4kze = parcelRequire("a4kze");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $k9TfW = parcelRequire("k9TfW");











var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");








var $caCU7 = parcelRequire("caCU7");


var $hlpSM = parcelRequire("hlpSM");

const $e2439a5908f943f7$var$i18n = (0, $kSwu1.defineMessages)({
    activeAgentsTitle: {
        id: "team-presence.agent-group-menu.title",
        defaultMessage: "{count, plural, =0 {Active agents ({count})} one {Active agents ({count})} other {Active agents ({count})}}"
    }
});
const $e2439a5908f943f7$var$styles = {
    root: "_0bjKvDKxmn _0KLXruoI2d _2OUyjtGk8v _1mT5xdRAKS _39xV02wBC3"
};
const $e2439a5908f943f7$export$62f6b3db6f977c3c = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { agents: agents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== agents.length || $[1] !== formatMessage) {
        t1 = formatMessage($e2439a5908f943f7$var$i18n.activeAgentsTitle, {
            count: agents.length
        });
        $[0] = agents.length;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== agents) {
        t2 = agents.map($e2439a5908f943f7$var$_temp);
        $[3] = agents;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2439a5908f943f7$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            maxHeight: 480,
            minWidth: 360,
            maxWidth: 360
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            isScrollable: true,
            title: t1
        }, t2)));
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
function $e2439a5908f943f7$var$_temp(agent) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caCU7.AgentPresenceMenuItem), {
        key: (0, $hlpSM.getAgentPresenceKey)({
            ...agent,
            includeActingUser: (0, $9wGTI.fg)("platform_move_presence_agents")
        }),
        agent: agent
    });
}









var $bcDqz = parcelRequire("bcDqz");

















var $3izAL = parcelRequire("3izAL");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");

const $54c653dc38243ab4$var$i18n = (0, $kSwu1.defineMessages)({
    groupOverflowLabel: {
        id: "team-presence.group.overflow.label",
        defaultMessage: "Overflow menu"
    }
});
const $54c653dc38243ab4$var$moreIndicatorButtonBaseStyle = (0, $buxP3.xcss)({
    minWidth: '28px',
    padding: 'space.0',
    marginInline: 'space.0',
    marginBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineOffset: 'space.050'
    }
});
const $54c653dc38243ab4$var$moreIndicatorStyle = (0, $buxP3.xcss)({
    padding: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    font: 'font.heading.xxsmall',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'radius.full',
    ':hover': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $54c653dc38243ab4$var$moreIndicatorActiveStyle = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
function $54c653dc38243ab4$export$20d7daf1abbf02fe(isOpen, count) {
    return (_, props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($54c653dc38243ab4$export$21d9599487cab049, {
            count: count,
            isOpen: isOpen,
            ...props
        });
    };
}
const $54c653dc38243ab4$export$21d9599487cab049 = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { count: count, isOpen: isOpen, onClick: onClick, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($54c653dc38243ab4$var$i18n.groupOverflowLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = isOpen && $54c653dc38243ab4$var$moreIndicatorActiveStyle;
    let t3;
    if ($[2] !== t2) {
        t3 = [
            $54c653dc38243ab4$var$moreIndicatorStyle,
            t2
        ];
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== count || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t3
        }, count);
        $[4] = count;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== onClick || $[8] !== t1 || $[9] !== t4 || $[10] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            "data-vc": "presence-overflow",
            "aria-label": t1,
            onClick: onClick,
            testId: testId,
            xcss: $54c653dc38243ab4$var$moreIndicatorButtonBaseStyle
        }, t4);
        $[7] = onClick;
        $[8] = t1;
        $[9] = t4;
        $[10] = testId;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};



var $iwQHw = parcelRequire("iwQHw");




const $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE = 4;
const $b28d1d3ecd80ad2b$var$styles = {
    root: "_2YLqiKLl21",
    presenceAgentWrapper: "_3iDTPbccYA _3YEZNOdnbC _0hPCNLDIqT _4kiQYAcM5X _0Of8r2FQfX _1wydGWFQfX"
};
const $b28d1d3ecd80ad2b$export$b69254d879536cde = (agents, count)=>{
    return (_, props, index)=>{
        const agent = agents.find((a)=>(0, $hlpSM.getAgentPresenceKey)({
                ...a,
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                includeActingUser: (0, $9wGTI.fg)('platform_move_presence_agents')
            }) === props.agentPresenceKey);
        if (!agent) return null;
         // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('platform_move_presence_agents')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b28d1d3ecd80ad2b$var$styles.presenceAgentWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent,
            isOverlapped: index > 0,
            size: "small",
            stackIndex: count - index,
            showBorder: true
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b28d1d3ecd80ad2b$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent,
            stackIndex: count - index,
            showBorder: true
        }));
    };
};
const $b28d1d3ecd80ad2b$export$192d6a5eae5d7b58 = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { agents: agents, isOpen: isOpen, onMoreClick: onMoreClick } = t0;
    let t1;
    if ($[0] !== agents) {
        t1 = agents.map($b28d1d3ecd80ad2b$var$_temp);
        $[0] = agents;
        $[1] = t1;
    } else t1 = $[1];
    const data = t1;
    let t2;
    if ($[2] !== agents || $[3] !== data.length) {
        t2 = $b28d1d3ecd80ad2b$export$b69254d879536cde(agents, data.length);
        $[2] = agents;
        $[3] = data.length;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = {
            render: t2
        };
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const t4 = data.length - $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE + 1;
    let t5;
    if ($[7] !== isOpen || $[8] !== t4) {
        t5 = (0, $54c653dc38243ab4$export$20d7daf1abbf02fe)(isOpen, t4);
        $[7] = isOpen;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = {
            render: t5
        };
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
        t7 = {
            Avatar: t3,
            MoreIndicator: t6
        };
        $[12] = t3;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== data || $[16] !== onMoreClick || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
            testId: "agent-presence-avatar-group",
            appearance: "stack",
            size: "small",
            maxCount: $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE,
            data: data,
            shouldPopupRenderToParent: false,
            onMoreClick: onMoreClick,
            overrides: t7
        });
        $[15] = data;
        $[16] = onMoreClick;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
};
function $b28d1d3ecd80ad2b$var$_temp(agent) {
    return {
        agentPresenceKey: (0, $hlpSM.getAgentPresenceKey)({
            ...agent,
            includeActingUser: (0, $9wGTI.fg)("platform_move_presence_agents")
        }),
        name: agent.name
    };
}






var $gvTDP = parcelRequire("gvTDP");


var $c6zRP = parcelRequire("c6zRP");

const $4dfa4fcf3782a7bf$var$hasValidLastActive = (lastActive)=>typeof lastActive === 'number' && Number.isFinite(lastActive);
const $4dfa4fcf3782a7bf$var$isMoreRecentPresence = (current, previous)=>$4dfa4fcf3782a7bf$var$hasValidLastActive(current.lastActive) && (!$4dfa4fcf3782a7bf$var$hasValidLastActive(previous.lastActive) || current.lastActive > previous.lastActive);
const $4dfa4fcf3782a7bf$var$i18n = (0, $kSwu1.defineMessages)({
    agentGroupLabel: {
        id: "team-presence.agent-group.label",
        defaultMessage: "Active agents on content"
    },
    externalAgentName: {
        id: "team-presence.external-agent.name",
        defaultMessage: "External agent"
    },
    rovoAgentName: {
        id: "team-presence.rovo-agent.name",
        defaultMessage: "Rovo"
    },
    claudeAgentName: {
        id: "team-presence.claude-agent.name",
        defaultMessage: "Claude"
    },
    cursorAgentName: {
        id: "team-presence.cursor-agent.name",
        defaultMessage: "Cursor"
    },
    codexAgentName: {
        id: "team-presence.codex-agent.name",
        defaultMessage: "Codex"
    },
    chatgptAgentName: {
        id: "team-presence.chatgpt-agent.name",
        defaultMessage: "ChatGPT"
    },
    diaAgentName: {
        id: "team-presence.dia-agent.name",
        defaultMessage: "Dia"
    },
    figmaAgentName: {
        id: "team-presence.figma-agent.name",
        defaultMessage: "Figma"
    },
    lovableAgentName: {
        id: "team-presence.lovable-agent.name",
        defaultMessage: "Lovable"
    },
    replitAgentName: {
        id: "team-presence.replit-agent.name",
        defaultMessage: "Replit"
    },
    grokAgentName: {
        id: "team-presence.grok-agent.name",
        defaultMessage: "Grok"
    },
    githubCopilotAgentName: {
        id: "team-presence.github-copilot-agent.name",
        defaultMessage: "GitHub Copilot"
    },
    vscodeAgentName: {
        id: "team-presence.vscode-agent.name",
        defaultMessage: "Visual Studio Code"
    },
    openCodeAgentName: {
        id: "team-presence.open-code-agent.name",
        defaultMessage: "Open Code"
    },
    hermesAgentName: {
        id: "team-presence.hermes-agent.name",
        defaultMessage: "Hermes"
    },
    kiroAgentName: {
        id: "team-presence.kiro-agent.name",
        defaultMessage: "Kiro"
    }
});
const $4dfa4fcf3782a7bf$var$styles = {
    nestedTrigger: "_3iDTPbccYA _0hPCNLDIqT"
};
const $4dfa4fcf3782a7bf$var$getUniqueAgents = (agents)=>{
    const uniqueAgents = new Map();
    agents?.forEach((agent)=>{
        if (agent) {
            const agentPresenceKey = (0, $hlpSM.getAgentPresenceKey)({
                ...agent,
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                includeActingUser: (0, $9wGTI.fg)('platform_move_presence_agents')
            });
            const previousAgent = uniqueAgents.get(agentPresenceKey);
            if (!previousAgent || !$4dfa4fcf3782a7bf$var$hasValidLastActive(previousAgent.lastActive) || $4dfa4fcf3782a7bf$var$isMoreRecentPresence(agent, previousAgent)) uniqueAgents.set(agentPresenceKey, agent);
        }
    });
    return Array.from(uniqueAgents.values());
};
const $4dfa4fcf3782a7bf$var$getUniqueAgentIds = (agentIds)=>Array.from(new Set(agentIds)).sort();
const $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId = (userId)=>userId.replace(/^agent:/, '');
const $4dfa4fcf3782a7bf$var$areAgentPresenceMetadataMapsEqual = (previousPresenceByKey, nextPresenceByKey)=>{
    if (previousPresenceByKey.size !== nextPresenceByKey.size) return false;
    return Array.from(nextPresenceByKey).every(([presenceKey, nextPresence])=>{
        const previousPresence = previousPresenceByKey.get(presenceKey);
        return previousPresence?.agentId === nextPresence.agentId && previousPresence?.actingUserId === nextPresence.actingUserId && previousPresence?.agentType === nextPresence.agentType && previousPresence?.permit?.isPermittedToEdit === nextPresence.permit?.isPermittedToEdit && // Compared as well as `isPermittedToEdit`, so a view-permit transition re-renders. Without
        // this an agent gaining or losing view permission would be invisible on the view route,
        // where it is the only permit it has.
        previousPresence?.permit?.isPermittedToView === nextPresence.permit?.isPermittedToView && previousPresence?.presenceActivity === nextPresence.presenceActivity && previousPresence?.presenceId === nextPresence.presenceId && previousPresence?.lastActive === nextPresence.lastActive && previousPresence?.presenceStatus === nextPresence.presenceStatus;
    });
};
const $4dfa4fcf3782a7bf$var$updateCachedAgentsById = (previousAgentsById, activeAgentIds, agentEntries)=>{
    const activeAgentIdSet = new Set(activeAgentIds);
    let nextAgentsById;
    for (const [agentId, agent] of agentEntries)if (activeAgentIdSet.has(agentId) && previousAgentsById.get(agentId) !== agent) {
        nextAgentsById ?? (nextAgentsById = new Map(previousAgentsById));
        nextAgentsById.set(agentId, agent);
    }
    previousAgentsById.forEach((_agent, agentId)=>{
        if (!activeAgentIdSet.has(agentId)) {
            nextAgentsById ?? (nextAgentsById = new Map(previousAgentsById));
            nextAgentsById.delete(agentId);
        }
    });
    return nextAgentsById ?? previousAgentsById;
};
const $4dfa4fcf3782a7bf$var$useActiveAgentPresence = (presenceProvider)=>{
    const $ = (0, $bDgLe.c)(10);
    const [t0] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [activeAgentIds, setActiveAgentIds] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[1] = t2;
    } else t2 = $[1];
    const [activeAgentPresenceKeys, setActiveAgentPresenceKeys] = (0, $cozmU.useState)(t2);
    const [activeAgentPresenceByKey, setActiveAgentPresenceByKey] = (0, $cozmU.useState)($4dfa4fcf3782a7bf$var$_temp);
    const lifecycleTimeoutRef = (0, $cozmU.useRef)(undefined);
    const provider = presenceProvider ?? collabEditProvider;
    let t3;
    let t4;
    if ($[2] !== presenceProvider || $[3] !== provider) {
        t3 = ()=>{
            const clearLifecycleTimeout = ()=>{
                if (lifecycleTimeoutRef.current !== undefined) {
                    window.clearTimeout(lifecycleTimeoutRef.current);
                    lifecycleTimeoutRef.current = undefined;
                }
            };
            const updateActiveAgentIds = (agentIds)=>{
                setActiveAgentIds((prev)=>{
                    const next = $4dfa4fcf3782a7bf$var$getUniqueAgentIds(agentIds);
                    return prev.length === next.length && prev.every((id, i)=>id === next[i]) ? prev : next;
                });
            };
            const updateActiveAgentPresenceKeys = (presenceKeys)=>{
                setActiveAgentPresenceKeys((prev_0)=>{
                    const next_0 = $4dfa4fcf3782a7bf$var$getUniqueAgentIds(presenceKeys);
                    return prev_0.length === next_0.length && prev_0.every((key, i_0)=>key === next_0[i_0]) ? prev_0 : next_0;
                });
            };
            const getRenderableAIProviderParticipants = ()=>{
                const aiProviderParticipants = provider?.getAIProviderParticipants() ?? [];
                if (!presenceProvider) return aiProviderParticipants;
                return aiProviderParticipants.filter($4dfa4fcf3782a7bf$var$_temp2);
            };
            const handleUpdatePresenceOld = ()=>{
                const aiProviderParticipants_0 = getRenderableAIProviderParticipants();
                const agentIds_0 = aiProviderParticipants_0.map($4dfa4fcf3782a7bf$var$_temp3);
                const agentPresenceByKey = new Map();
                aiProviderParticipants_0.forEach((agent_1)=>{
                    const agentId = $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId(agent_1.userId);
                    agentPresenceByKey.set((0, $hlpSM.getAgentPresenceKey)({
                        id: agentId,
                        actingUserId: undefined,
                        includeActingUser: false
                    }), {
                        agentId: agentId,
                        agentType: agent_1.agentType
                    });
                });
                updateActiveAgentIds(agentIds_0);
                updateActiveAgentPresenceKeys(Array.from(agentPresenceByKey.keys()));
                setActiveAgentPresenceByKey((previous)=>$4dfa4fcf3782a7bf$var$areAgentPresenceMetadataMapsEqual(previous, agentPresenceByKey) ? previous : agentPresenceByKey);
            };
            const handleUpdatePresenceNew = ()=>{
                clearLifecycleTimeout();
                const now = Date.now();
                const aiProviderParticipants_1 = getRenderableAIProviderParticipants().filter((agent_2)=>(0, $c6zRP.getAgentPresenceStatus)(agent_2, now) !== "expired");
                const agentPresenceByKey_0 = new Map();
                let nextLifecycleBoundary;
                aiProviderParticipants_1.forEach((agent_3)=>{
                    const agentId_0 = $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId(agent_3.userId);
                    const presenceKey = (0, $hlpSM.getAgentPresenceKey)({
                        id: agentId_0,
                        actingUserId: agent_3.actingUserId,
                        includeActingUser: true
                    });
                    const lifecycleBoundary = (0, $c6zRP.getNextAgentPresenceBoundary)(agent_3.lastActive, now);
                    if (lifecycleBoundary !== undefined && (nextLifecycleBoundary === undefined || lifecycleBoundary < nextLifecycleBoundary)) nextLifecycleBoundary = lifecycleBoundary;
                    const agentPresence = {
                        agentId: agentId_0,
                        actingUserId: agent_3.actingUserId,
                        agentType: agent_3.agentType,
                        permit: {
                            isPermittedToEdit: agent_3.permit?.isPermittedToEdit,
                            isPermittedToView: agent_3.permit?.isPermittedToView
                        },
                        presenceActivity: agent_3.presenceActivity,
                        presenceId: agent_3.presenceId ?? agent_3.userId,
                        lastActive: agent_3.lastActive,
                        presenceStatus: (0, $c6zRP.getAgentPresenceStatus)(agent_3, now)
                    };
                    const previousPresence = agentPresenceByKey_0.get(presenceKey);
                    if (!previousPresence || $4dfa4fcf3782a7bf$var$isMoreRecentPresence(agentPresence, previousPresence)) agentPresenceByKey_0.set(presenceKey, agentPresence);
                });
                updateActiveAgentIds(Array.from(agentPresenceByKey_0.values()).map($4dfa4fcf3782a7bf$var$_temp4));
                updateActiveAgentPresenceKeys(Array.from(agentPresenceByKey_0.keys()));
                setActiveAgentPresenceByKey((prev_1)=>$4dfa4fcf3782a7bf$var$areAgentPresenceMetadataMapsEqual(prev_1, agentPresenceByKey_0) ? prev_1 : agentPresenceByKey_0);
                if (nextLifecycleBoundary !== undefined) lifecycleTimeoutRef.current = window.setTimeout(handleUpdatePresence, Math.max(0, nextLifecycleBoundary - now));
            };
            const handleUpdatePresence = ()=>{
                if ((0, $9wGTI.fg)("platform_move_presence_agents")) {
                    handleUpdatePresenceNew();
                    return;
                }
                handleUpdatePresenceOld();
            };
            handleUpdatePresence();
            provider?.on("presence", handleUpdatePresence);
            if ((0, $9wGTI.fg)("platform_move_presence_agents")) provider?.on("presence:changed", handleUpdatePresence);
            return ()=>{
                clearLifecycleTimeout();
                provider?.off("presence", handleUpdatePresence);
                if ((0, $9wGTI.fg)("platform_move_presence_agents")) provider?.off("presence:changed", handleUpdatePresence);
            };
        };
        t4 = [
            presenceProvider,
            provider
        ];
        $[2] = presenceProvider;
        $[3] = provider;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] !== activeAgentIds || $[7] !== activeAgentPresenceByKey || $[8] !== activeAgentPresenceKeys) {
        t5 = {
            activeAgentIds: activeAgentIds,
            activeAgentPresenceKeys: activeAgentPresenceKeys,
            activeAgentPresenceByKey: activeAgentPresenceByKey
        };
        $[6] = activeAgentIds;
        $[7] = activeAgentPresenceByKey;
        $[8] = activeAgentPresenceKeys;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $4dfa4fcf3782a7bf$var$buildAssistanceServiceParams = (cloudId)=>({
        siteId: cloudId,
        product: 'confluence',
        experienceId: 'ai-mate',
        touchpointSource: 'aiAgentPresence'
    });
const $4dfa4fcf3782a7bf$var$AgentPresenceView = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { activeAgents: activeAgents, isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isAgentGroupOverflowOpen, setIsAgentGroupOverflowOpen] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== activeAgents || $[1] !== isNestedInPresenceAvatarGroup || $[2] !== onActiveAgentsChange) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("platform_move_presence_agents") || !isNestedInPresenceAvatarGroup || !onActiveAgentsChange) return;
            onActiveAgentsChange(activeAgents);
            return ()=>{
                onActiveAgentsChange([]);
            };
        };
        t2 = [
            activeAgents,
            isNestedInPresenceAvatarGroup,
            onActiveAgentsChange
        ];
        $[0] = activeAgents;
        $[1] = isNestedInPresenceAvatarGroup;
        $[2] = onActiveAgentsChange;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== createAnalyticsEvent) {
        t3 = (agentCount)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "aiAgentPresence",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiAgentPresenceGroupOverflow",
                    product: "confluence",
                    attributes: {
                        agents: agentCount
                    }
                }
            }).fire();
            setIsAgentGroupOverflowOpen($4dfa4fcf3782a7bf$var$_temp5);
        };
        $[5] = createAnalyticsEvent;
        $[6] = t3;
    } else t3 = $[6];
    const handleAgentGroupOverflowMenuClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsAgentGroupOverflowOpen(false);
        };
        $[7] = t4;
    } else t4 = $[7];
    const handleAgentGroupOverflowMenuClose = t4;
    let t5;
    if ($[8] !== activeAgents) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2439a5908f943f7$export$62f6b3db6f977c3c), {
                agents: activeAgents
            });
        $[8] = activeAgents;
        $[9] = t5;
    } else t5 = $[9];
    const renderAgentGroupOverflowMenu = t5;
    let t6;
    let t7;
    if ($[10] !== activeAgents.length) {
        t6 = ()=>{
            if (!activeAgents.length) setIsAgentGroupOverflowOpen(false);
        };
        t7 = [
            activeAgents.length
        ];
        $[10] = activeAgents.length;
        $[11] = t6;
        $[12] = t7;
    } else {
        t6 = $[11];
        t7 = $[12];
    }
    (0, $cozmU.useEffect)(t6, t7);
    if (!activeAgents?.length || isNestedInPresenceAvatarGroup) return null;
    let t8;
    if ($[13] !== activeAgents || $[14] !== formatMessage || $[15] !== handleAgentGroupOverflowMenuClick || $[16] !== isAgentGroupOverflowOpen || $[17] !== isNestedInPresenceAvatarGroup) {
        t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ...triggerProps,
                paddingInline: "space.025",
                xcss: isNestedInPresenceAvatarGroup && $4dfa4fcf3782a7bf$var$styles.nestedTrigger,
                "aria-label": isNestedInPresenceAvatarGroup ? undefined : formatMessage($4dfa4fcf3782a7bf$var$i18n.agentGroupLabel),
                role: isNestedInPresenceAvatarGroup ? undefined : "region"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b28d1d3ecd80ad2b$export$192d6a5eae5d7b58), {
                agents: activeAgents,
                isOpen: isAgentGroupOverflowOpen,
                onMoreClick: ()=>handleAgentGroupOverflowMenuClick(activeAgents.length)
            }));
        $[13] = activeAgents;
        $[14] = formatMessage;
        $[15] = handleAgentGroupOverflowMenuClick;
        $[16] = isAgentGroupOverflowOpen;
        $[17] = isNestedInPresenceAvatarGroup;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== isAgentGroupOverflowOpen || $[20] !== renderAgentGroupOverflowMenu || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            placement: "bottom-end",
            isOpen: isAgentGroupOverflowOpen,
            onClose: handleAgentGroupOverflowMenuClose,
            content: renderAgentGroupOverflowMenu,
            trigger: t8
        });
        $[19] = isAgentGroupOverflowOpen;
        $[20] = renderAgentGroupOverflowMenu;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $4dfa4fcf3782a7bf$var$useAgentsByIds = (0, $lJ6db.createHookWithAssistanceService)(({ agentIds: agentIds, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { data: data } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentPresenceAgentsByIds',
            ...agentIds.slice().sort()
        ],
        queryFn: async ()=>{
            const agentResults = await Promise.allSettled(agentIds.map((agentId)=>assistanceService.getAgentDetails(agentId)));
            return agentResults.flatMap((result)=>result.status === 'fulfilled' ? [
                    result.value
                ] : []);
        },
        enabled: agentIds.length > 0
    });
    return data ?? [];
});
const $4dfa4fcf3782a7bf$export$3c0017d495bde3b3 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { activeAgentIds: activeAgentIds, activeAgentPresenceKeys: activeAgentPresenceKeys, activeAgentPresenceByKey: activeAgentPresenceByKey } = $4dfa4fcf3782a7bf$var$useActiveAgentPresence(presenceProvider);
    let t1;
    if ($[0] !== cloudId) {
        t1 = $4dfa4fcf3782a7bf$var$buildAssistanceServiceParams(cloudId);
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== activeAgentIds || $[3] !== t1) {
        t2 = {
            agentIds: activeAgentIds,
            assistanceServiceParams: t1
        };
        $[2] = activeAgentIds;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const agentsFromAssistanceService = $4dfa4fcf3782a7bf$var$useAgentsByIds(t2);
    const [agentsById, setAgentsById] = (0, $cozmU.useState)($4dfa4fcf3782a7bf$var$_temp6);
    let t3;
    let t4;
    if ($[5] !== activeAgentIds || $[6] !== agentsFromAssistanceService) {
        t3 = ()=>{
            setAgentsById((previousAgentsById)=>$4dfa4fcf3782a7bf$var$updateCachedAgentsById(previousAgentsById, activeAgentIds, agentsFromAssistanceService.map($4dfa4fcf3782a7bf$var$_temp7)));
        };
        t4 = [
            activeAgentIds,
            agentsFromAssistanceService
        ];
        $[5] = activeAgentIds;
        $[6] = agentsFromAssistanceService;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== activeAgentPresenceByKey || $[10] !== activeAgentPresenceKeys || $[11] !== agentsById || $[12] !== agentsFromAssistanceService) {
        let t6;
        if ($[14] !== activeAgentPresenceByKey || $[15] !== agentsById || $[16] !== agentsFromAssistanceService) {
            t6 = (presenceKey)=>{
                const presence = activeAgentPresenceByKey.get(presenceKey);
                const agentId = presence?.agentId;
                const agent_1 = agentId !== undefined ? agentsFromAssistanceService.find((agent_0)=>agent_0.id === agentId) ?? agentsById.get(agentId) : undefined;
                return agent_1 ? {
                    ...agent_1,
                    ...presence
                } : agent_1;
            };
            $[14] = activeAgentPresenceByKey;
            $[15] = agentsById;
            $[16] = agentsFromAssistanceService;
            $[17] = t6;
        } else t6 = $[17];
        t5 = $4dfa4fcf3782a7bf$var$getUniqueAgents(activeAgentPresenceKeys.map(t6));
        $[9] = activeAgentPresenceByKey;
        $[10] = activeAgentPresenceKeys;
        $[11] = agentsById;
        $[12] = agentsFromAssistanceService;
        $[13] = t5;
    } else t5 = $[13];
    const activeAgents = t5;
    let t6;
    if ($[18] !== activeAgents || $[19] !== isNestedInPresenceAvatarGroup || $[20] !== onActiveAgentsChange) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$AgentPresenceView, {
            activeAgents: activeAgents,
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange
        });
        $[18] = activeAgents;
        $[19] = isNestedInPresenceAvatarGroup;
        $[20] = onActiveAgentsChange;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
}; // Keep the gate-off streaming cohorts on the existing resolver so the shared page/editor path has
// an independent rollback switch.
const $4dfa4fcf3782a7bf$var$createFallbackAgent = (agentId, name)=>({
        id: agentId,
        identity_account_id: null,
        named_id: agentId,
        name: name,
        description: null,
        creator_type: 'CUSTOMER',
        available_plugins: {},
        is_default: false,
        actor_type: 'AGENT',
        user_defined_conversation_starters: null,
        favourite: false,
        deactivated: false,
        isExternalAgentFallback: true
    });
const $4dfa4fcf3782a7bf$var$hasConcreteAgentId = ({ agentId: agentId, agentType: agentType })=>Boolean(agentId) && agentId !== agentType;
const $4dfa4fcf3782a7bf$var$createIdentityAgent = (identifier, user, fallbackAgentName)=>({
        ...$4dfa4fcf3782a7bf$var$createFallbackAgent(identifier.agentId, fallbackAgentName),
        agentType: identifier.agentType,
        avatarUrl: user.avatar,
        id: identifier.agentId,
        identity_account_id: user.userId,
        isExternalAgentFallback: false,
        named_id: user.userId,
        name: user.name
    });
const $4dfa4fcf3782a7bf$var$createTypedFallbackAgent = (identifier, fallbackAgentName, agentIcon)=>({
        ...$4dfa4fcf3782a7bf$var$createFallbackAgent(identifier.agentId, fallbackAgentName),
        agentType: identifier.agentType,
        ...agentIcon ? {
            agentIcon: agentIcon
        } : {}
    });
const $4dfa4fcf3782a7bf$var$createRovoChatAgent = (identifier, name)=>$4dfa4fcf3782a7bf$var$createTypedFallbackAgent({
        ...identifier,
        agentId: 'rovo_chat'
    }, name, 'rovo');
const $4dfa4fcf3782a7bf$var$resolveStudioAgent = async (identifier, assistanceService, fallbackAgentName, rovoAgentName)=>{
    if (!$4dfa4fcf3782a7bf$var$hasConcreteAgentId(identifier)) return $4dfa4fcf3782a7bf$var$createRovoChatAgent(identifier, rovoAgentName);
    try {
        const agent = await assistanceService.getAgentDetailsByIdentityAccountId(identifier.agentId);
        if ((0, $2yWJZ.isDefaultRovoChat)({
            agentId: agent.id,
            agentNamedId: agent.named_id
        })) return $4dfa4fcf3782a7bf$var$createRovoChatAgent(identifier, rovoAgentName);
        const agentBrand = agent.creator_type === 'OOTB' ? (0, $a4kze.getAgentBrand)(agent.name.replace(/ Agent$/, '')) : undefined;
        return {
            ...agent,
            agentType: identifier.agentType,
            ...agentBrand && {
                agentIcon: agentBrand.agentIcon
            }
        };
    } catch  {
        return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
    }
};
const $4dfa4fcf3782a7bf$var$resolveStudioAgentById = async (identifier, assistanceService, fallbackAgentName)=>{
    try {
        return {
            ...await assistanceService.getAgentDetails(identifier.agentId),
            agentType: identifier.agentType
        };
    } catch  {
        return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
    }
};
const $4dfa4fcf3782a7bf$var$resolveIdentityAgent = async (identifier, identityUsersByIdPromise, fallbackAgentName)=>{
    const user = (await identityUsersByIdPromise).get(identifier.agentId);
    return user ? $4dfa4fcf3782a7bf$var$createIdentityAgent(identifier, user, fallbackAgentName) : $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
};
const $4dfa4fcf3782a7bf$var$resolveAgentIdentifier = (identifier, assistanceService, identityUsersByIdPromise, fallbackAgentName, agentNames)=>{
    switch(identifier.agentType){
        case 'claude':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.claude, 'claude');
        case 'codex':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.codex, 'codex');
        case 'cursor':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.cursor, 'cursor');
        case 'chatgpt':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.chatgpt, 'chatgpt');
        case 'dia':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.dia, 'dia');
        case 'figma':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.figma, 'figma');
        case 'lovable':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.lovable, 'lovable');
        case 'replit':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.replit, 'replit');
        case 'grok':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.grok, 'grok');
        case 'github_copilot':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.github_copilot, 'github-copilot');
        case 'vscode':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.vscode, 'vscode');
        case 'open_code':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.open_code, 'open-code');
        case 'hermes':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.hermes, 'hermes');
        case 'kiro':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, agentNames.kiro, 'kiro');
        case 'convo-ai':
            return $4dfa4fcf3782a7bf$var$resolveStudioAgent(identifier, assistanceService, fallbackAgentName, agentNames.rovo);
        case 'mcp':
            return $4dfa4fcf3782a7bf$var$resolveIdentityAgent(identifier, identityUsersByIdPromise, fallbackAgentName);
        case 'twg':
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
        case 'rovo_chat':
            return $4dfa4fcf3782a7bf$var$createRovoChatAgent(identifier, agentNames.rovo);
        default:
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if (!(0, $9wGTI.fg)('platform_move_presence_agents') && identifier.agentType === undefined) return $4dfa4fcf3782a7bf$var$resolveStudioAgentById(identifier, assistanceService, fallbackAgentName);
            return $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
    }
};
const $4dfa4fcf3782a7bf$var$useAgentsByIdsWithAgentEdits = (0, $lJ6db.createHookWithAssistanceService)(({ agentIdentifiers: agentIdentifiers, fallbackAgentName: fallbackAgentName, agentNames: agentNames, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { data: data } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentPresenceAgentsByIds',
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('confluence_agent_presence_profile_by_type') ? 'type-directed' : 'legacy',
            ...agentIdentifiers.map(({ agentId: agentId, agentType: agentType })=>`${agentType ?? ''}:${agentId}`).sort()
        ],
        queryFn: async ()=>{
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if (!(0, $9wGTI.fg)('confluence_agent_presence_profile_by_type')) {
                const entries = await Promise.all(agentIdentifiers.map(async (identifier)=>{
                    const { agentId: agentId } = identifier;
                    try {
                        return [
                            agentId,
                            await assistanceService.getAgentDetails(agentId)
                        ];
                    } catch  {
                        try {
                            return [
                                agentId,
                                await assistanceService.getAgentDetailsByIdentityAccountId(agentId)
                            ];
                        } catch  {
                            return [
                                agentId,
                                $4dfa4fcf3782a7bf$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent')
                            ];
                        }
                    }
                }));
                return new Map(entries);
            }
            const identityAgentIds = agentIdentifiers.flatMap((identifier)=>$4dfa4fcf3782a7bf$var$hasConcreteAgentId(identifier) && identifier.agentType === 'mcp' ? [
                    identifier.agentId
                ] : []);
            const identityUsersByIdPromise = identityAgentIds.length > 0 ? (0, $k9TfW.fetchPresenceAGGUsers)(identityAgentIds).then((users)=>new Map(users.map((user)=>[
                        user.userId,
                        user
                    ]))).catch(()=>new Map()) : Promise.resolve(new Map());
            return new Map(await Promise.all(agentIdentifiers.map(async (identifier)=>[
                    identifier.agentId,
                    await $4dfa4fcf3782a7bf$var$resolveAgentIdentifier(identifier, assistanceService, identityUsersByIdPromise, fallbackAgentName, agentNames)
                ])));
        },
        enabled: agentIdentifiers.length > 0
    });
    return data ?? null;
});
const $4dfa4fcf3782a7bf$var$AgentPresenceComponentWithAgentEdits = (t0)=>{
    const $ = (0, $bDgLe.c)(70);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { activeAgentIds: activeAgentIds, activeAgentPresenceKeys: activeAgentPresenceKeys, activeAgentPresenceByKey: activeAgentPresenceByKey } = $4dfa4fcf3782a7bf$var$useActiveAgentPresence(presenceProvider);
    let agentTypeById;
    if ($[0] !== activeAgentPresenceByKey || $[1] !== activeAgentPresenceKeys) {
        agentTypeById = new Map();
        activeAgentPresenceKeys.forEach((presenceKey)=>{
            const presence = activeAgentPresenceByKey.get(presenceKey);
            if (presence && !agentTypeById.has(presence.agentId)) agentTypeById.set(presence.agentId, presence.agentType);
        });
        $[0] = activeAgentPresenceByKey;
        $[1] = activeAgentPresenceKeys;
        $[2] = agentTypeById;
    } else agentTypeById = $[2];
    const activeAgentTypeById = agentTypeById;
    let t1;
    if ($[3] !== activeAgentIds || $[4] !== activeAgentTypeById) {
        let t2;
        if ($[6] !== activeAgentTypeById) {
            t2 = (agentId)=>({
                    agentId: agentId,
                    agentType: activeAgentTypeById.get(agentId)
                });
            $[6] = activeAgentTypeById;
            $[7] = t2;
        } else t2 = $[7];
        t1 = activeAgentIds.map(t2);
        $[3] = activeAgentIds;
        $[4] = activeAgentTypeById;
        $[5] = t1;
    } else t1 = $[5];
    const activeAgentIdentifiers = t1;
    let t2;
    if ($[8] !== formatMessage) {
        t2 = formatMessage($4dfa4fcf3782a7bf$var$i18n.externalAgentName);
        $[8] = formatMessage;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== formatMessage) {
        t3 = formatMessage($4dfa4fcf3782a7bf$var$i18n.chatgptAgentName);
        $[10] = formatMessage;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== formatMessage) {
        t4 = formatMessage($4dfa4fcf3782a7bf$var$i18n.claudeAgentName);
        $[12] = formatMessage;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($4dfa4fcf3782a7bf$var$i18n.codexAgentName);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== formatMessage) {
        t6 = formatMessage($4dfa4fcf3782a7bf$var$i18n.cursorAgentName);
        $[16] = formatMessage;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== formatMessage) {
        t7 = formatMessage($4dfa4fcf3782a7bf$var$i18n.diaAgentName);
        $[18] = formatMessage;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== formatMessage) {
        t8 = formatMessage($4dfa4fcf3782a7bf$var$i18n.figmaAgentName);
        $[20] = formatMessage;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== formatMessage) {
        t9 = formatMessage($4dfa4fcf3782a7bf$var$i18n.githubCopilotAgentName);
        $[22] = formatMessage;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== formatMessage) {
        t10 = formatMessage($4dfa4fcf3782a7bf$var$i18n.grokAgentName);
        $[24] = formatMessage;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== formatMessage) {
        t11 = formatMessage($4dfa4fcf3782a7bf$var$i18n.hermesAgentName);
        $[26] = formatMessage;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== formatMessage) {
        t12 = formatMessage($4dfa4fcf3782a7bf$var$i18n.kiroAgentName);
        $[28] = formatMessage;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== formatMessage) {
        t13 = formatMessage($4dfa4fcf3782a7bf$var$i18n.lovableAgentName);
        $[30] = formatMessage;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== formatMessage) {
        t14 = formatMessage($4dfa4fcf3782a7bf$var$i18n.openCodeAgentName);
        $[32] = formatMessage;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== formatMessage) {
        t15 = formatMessage($4dfa4fcf3782a7bf$var$i18n.replitAgentName);
        $[34] = formatMessage;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== formatMessage) {
        t16 = formatMessage($4dfa4fcf3782a7bf$var$i18n.rovoAgentName);
        $[36] = formatMessage;
        $[37] = t16;
    } else t16 = $[37];
    let t17;
    if ($[38] !== formatMessage) {
        t17 = formatMessage($4dfa4fcf3782a7bf$var$i18n.vscodeAgentName);
        $[38] = formatMessage;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t17 || $[48] !== t3 || $[49] !== t4 || $[50] !== t5 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9) {
        t18 = {
            chatgpt: t3,
            claude: t4,
            codex: t5,
            cursor: t6,
            dia: t7,
            figma: t8,
            github_copilot: t9,
            grok: t10,
            hermes: t11,
            kiro: t12,
            lovable: t13,
            open_code: t14,
            replit: t15,
            rovo: t16,
            vscode: t17
        };
        $[40] = t10;
        $[41] = t11;
        $[42] = t12;
        $[43] = t13;
        $[44] = t14;
        $[45] = t15;
        $[46] = t16;
        $[47] = t17;
        $[48] = t3;
        $[49] = t4;
        $[50] = t5;
        $[51] = t6;
        $[52] = t7;
        $[53] = t8;
        $[54] = t9;
        $[55] = t18;
    } else t18 = $[55];
    let t19;
    if ($[56] !== cloudId) {
        t19 = $4dfa4fcf3782a7bf$var$buildAssistanceServiceParams(cloudId);
        $[56] = cloudId;
        $[57] = t19;
    } else t19 = $[57];
    let t20;
    if ($[58] !== activeAgentIdentifiers || $[59] !== t18 || $[60] !== t19 || $[61] !== t2) {
        t20 = {
            agentIdentifiers: activeAgentIdentifiers,
            fallbackAgentName: t2,
            agentNames: t18,
            assistanceServiceParams: t19
        };
        $[58] = activeAgentIdentifiers;
        $[59] = t18;
        $[60] = t19;
        $[61] = t2;
        $[62] = t20;
    } else t20 = $[62];
    const resolvedAgentsById = $4dfa4fcf3782a7bf$var$useAgentsByIdsWithAgentEdits(t20);
    let t21;
    if ($[63] !== activeAgentIds || $[64] !== activeAgentPresenceByKey || $[65] !== activeAgentPresenceKeys || $[66] !== isNestedInPresenceAvatarGroup || $[67] !== onActiveAgentsChange || $[68] !== resolvedAgentsById) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$ResolvedAgentPresenceComponent, {
            activeAgentIds: activeAgentIds,
            activeAgentPresenceKeys: activeAgentPresenceKeys,
            activeAgentPresenceByKey: activeAgentPresenceByKey,
            resolvedAgentsById: resolvedAgentsById,
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange
        });
        $[63] = activeAgentIds;
        $[64] = activeAgentPresenceByKey;
        $[65] = activeAgentPresenceKeys;
        $[66] = isNestedInPresenceAvatarGroup;
        $[67] = onActiveAgentsChange;
        $[68] = resolvedAgentsById;
        $[69] = t21;
    } else t21 = $[69];
    return t21;
};
const $4dfa4fcf3782a7bf$var$SharedAgentPresenceComponentWithAgentEdits = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { agentNames: agentNames, fallbackAgentName: fallbackAgentName } = (0, $gvTDP.useAgentPresenceResolverMessages)();
    const { activeAgentIds: activeAgentIds, activeAgentPresenceKeys: activeAgentPresenceKeys, activeAgentPresenceByKey: activeAgentPresenceByKey } = $4dfa4fcf3782a7bf$var$useActiveAgentPresence(presenceProvider);
    let agentTypeById;
    if ($[0] !== activeAgentPresenceByKey || $[1] !== activeAgentPresenceKeys) {
        agentTypeById = new Map();
        activeAgentPresenceKeys.forEach((presenceKey)=>{
            const presence = activeAgentPresenceByKey.get(presenceKey);
            if (presence && !agentTypeById.has(presence.agentId)) agentTypeById.set(presence.agentId, presence.agentType);
        });
        $[0] = activeAgentPresenceByKey;
        $[1] = activeAgentPresenceKeys;
        $[2] = agentTypeById;
    } else agentTypeById = $[2];
    const activeAgentTypeById = agentTypeById;
    let t1;
    if ($[3] !== activeAgentIds || $[4] !== activeAgentTypeById) {
        let t2;
        if ($[6] !== activeAgentTypeById) {
            t2 = (agentId)=>({
                    agentId: agentId,
                    agentType: activeAgentTypeById.get(agentId)
                });
            $[6] = activeAgentTypeById;
            $[7] = t2;
        } else t2 = $[7];
        t1 = activeAgentIds.map(t2);
        $[3] = activeAgentIds;
        $[4] = activeAgentTypeById;
        $[5] = t1;
    } else t1 = $[5];
    const activeAgentIdentifiers = t1;
    let t2;
    if ($[8] !== cloudId) {
        t2 = (0, $gvTDP.buildAgentPresenceAssistanceServiceParams)(cloudId);
        $[8] = cloudId;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== activeAgentIdentifiers || $[11] !== agentNames || $[12] !== fallbackAgentName || $[13] !== t2) {
        t3 = {
            agentIdentifiers: activeAgentIdentifiers,
            fallbackAgentName: fallbackAgentName,
            agentNames: agentNames,
            assistanceServiceParams: t2
        };
        $[10] = activeAgentIdentifiers;
        $[11] = agentNames;
        $[12] = fallbackAgentName;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    const resolvedAgentsById = (0, $gvTDP.useAgentsByIdsWithAgentEdits)(t3);
    let t4;
    if ($[15] !== activeAgentIds || $[16] !== activeAgentPresenceByKey || $[17] !== activeAgentPresenceKeys || $[18] !== isNestedInPresenceAvatarGroup || $[19] !== onActiveAgentsChange || $[20] !== resolvedAgentsById) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$ResolvedAgentPresenceComponent, {
            activeAgentIds: activeAgentIds,
            activeAgentPresenceKeys: activeAgentPresenceKeys,
            activeAgentPresenceByKey: activeAgentPresenceByKey,
            resolvedAgentsById: resolvedAgentsById,
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange
        });
        $[15] = activeAgentIds;
        $[16] = activeAgentPresenceByKey;
        $[17] = activeAgentPresenceKeys;
        $[18] = isNestedInPresenceAvatarGroup;
        $[19] = onActiveAgentsChange;
        $[20] = resolvedAgentsById;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
function $4dfa4fcf3782a7bf$var$ResolvedAgentPresenceComponent({ activeAgentIds: activeAgentIds, activeAgentPresenceKeys: activeAgentPresenceKeys, activeAgentPresenceByKey: activeAgentPresenceByKey, resolvedAgentsById: resolvedAgentsById, isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange }) {
    const [agentsById, setAgentsById] = (0, $cozmU.useState)(()=>new Map());
    (0, $cozmU.useEffect)(()=>{
        setAgentsById((previous)=>{
            return $4dfa4fcf3782a7bf$var$updateCachedAgentsById(previous, activeAgentIds, resolvedAgentsById ?? []);
        });
    }, [
        activeAgentIds,
        resolvedAgentsById
    ]);
    const activeAgents = (0, $cozmU.useMemo)(()=>$4dfa4fcf3782a7bf$var$getUniqueAgents(activeAgentPresenceKeys.map((presenceKey)=>{
            const presence = activeAgentPresenceByKey.get(presenceKey);
            const agentId = presence?.agentId;
            const resolvedAgent = agentId ? resolvedAgentsById?.get(agentId) : undefined;
            const cachedAgent = agentId ? agentsById.get(agentId) : undefined; // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            const agent = (0, $9wGTI.fg)('confluence_agent_presence_profile_by_type') ? (resolvedAgent?.agentType === presence?.agentType ? resolvedAgent : undefined) ?? (cachedAgent?.agentType === presence?.agentType ? cachedAgent : undefined) : resolvedAgent ?? cachedAgent;
            return agent ? {
                ...agent,
                ...presence
            } : agent;
        })), [
        activeAgentPresenceByKey,
        activeAgentPresenceKeys,
        agentsById,
        resolvedAgentsById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$AgentPresenceView, {
        activeAgents: activeAgents,
        isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
        onActiveAgentsChange: onActiveAgentsChange
    });
}
const $4dfa4fcf3782a7bf$export$b5ab3015117320e0 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    if (!isAdminHubAIEnabled || !isAIEarlyAccessEnabled || !(0, $6mKj3.expValEquals)("reinstate_confluence_agent_presence", "isEnabled", true) || isNestedInPresenceAvatarGroup && !(0, $9wGTI.fg)("platform_move_presence_agents")) return null;
    let t1;
    if ($[0] !== isNestedInPresenceAvatarGroup || $[1] !== onActiveAgentsChange || $[2] !== presenceProvider) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
        }, (0, $9wGTI.fg)("confluence_agent_presence_shared_agent_code") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$SharedAgentPresenceComponentWithAgentEdits, {
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange,
            presenceProvider: presenceProvider
        }) : (0, $6mKj3.expValEquals)("platform_editor_agent_be_streaming", "isEnabled", true) || (0, $6mKj3.UNSAFE_isExperimentEnabledNoExposure)("platform_editor_ai_streaming_ux_experience_m1") || (0, $9wGTI.fg)("platform_move_presence_agents") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$AgentPresenceComponentWithAgentEdits, {
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange,
            presenceProvider: presenceProvider
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$export$3c0017d495bde3b3, {
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange,
            presenceProvider: presenceProvider
        }));
        $[0] = isNestedInPresenceAvatarGroup;
        $[1] = onActiveAgentsChange;
        $[2] = presenceProvider;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
function $4dfa4fcf3782a7bf$var$_temp() {
    return new Map();
}
function $4dfa4fcf3782a7bf$var$_temp2(agent) {
    return agent.permit?.isPermittedToView || agent.permit?.isPermittedToEdit;
}
function $4dfa4fcf3782a7bf$var$_temp3(agent_0) {
    return $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId(agent_0.userId);
}
function $4dfa4fcf3782a7bf$var$_temp4(t0) {
    const { agentId: agentId_1 } = t0;
    return agentId_1;
}
function $4dfa4fcf3782a7bf$var$_temp5(isAgentGroupOverflowOpenState) {
    return !isAgentGroupOverflowOpenState;
}
function $4dfa4fcf3782a7bf$var$_temp6() {
    return new Map();
}
function $4dfa4fcf3782a7bf$var$_temp7(agent) {
    return [
        agent.id,
        agent
    ];
}
module.exports["AgentPresenceComponent"] = $4dfa4fcf3782a7bf$export$3c0017d495bde3b3;
module.exports["AgentPresence"] = $4dfa4fcf3782a7bf$export$b5ab3015117320e0;

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $65e219e9f9df9520$var$getCacheEpoch = ()=>(0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store).storeState.getState().epoch;
const $65e219e9f9df9520$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    storeApi.actions.clearCache();
};
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["clearQueryCache"] = $65e219e9f9df9520$export$467f2e03eb04239a;
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("2yWJZ", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $2khPJ.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("caCU7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9d7Pd = parcelRequire("9d7Pd");


var $9DHhW = parcelRequire("9DHhW");


var $arQY7 = parcelRequire("arQY7");


var $fnCzB = parcelRequire("fnCzB");


var $9wGTI = parcelRequire("9wGTI");


var $9oOTt = parcelRequire("9oOTt");


var $iwQHw = parcelRequire("iwQHw");


var $c6zRP = parcelRequire("c6zRP");

const $6721937fde404080$var$i18n = (0, $kSwu1.defineMessages)({
    editing: {
        id: "team-presence.agent-group-menu.editing",
        defaultMessage: "Editing"
    },
    editingWithActor: {
        id: "team-presence.agent-group-menu.editing-with-actor",
        defaultMessage: "with {actorName} \u2022 Editing"
    },
    viewing: {
        id: "team-presence.agent-group-menu.viewing",
        defaultMessage: "Viewing"
    },
    viewingWithActor: {
        id: "team-presence.agent-group-menu.viewing-with-actor",
        defaultMessage: "with {actorName} \u2022 Viewing"
    }
});
const $6721937fde404080$export$e32187f91d1fd188 = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { actingUserAvatarUrl: actingUserAvatarUrl, actingUserName: actingUserName, agent: agent } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (agentId)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "aiAgentPresenceGroupOverflowMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiAgentPresenceGroupOverflowMenuItem",
                    product: "confluence",
                    attributes: {
                        agentId: agentId
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const handleAgentClick = t1;
    let t2;
    if ($[2] !== actingUserName || $[3] !== agent) {
        t2 = ()=>{
            if (!(0, $9wGTI.fg)("platform_move_presence_agents")) return;
            const activityDescription = agent.presenceActivity === "editor" ? actingUserName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$6721937fde404080$var$i18n.editingWithActor,
                values: {
                    actorName: actingUserName
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6721937fde404080$var$i18n.editing) : actingUserName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$6721937fde404080$var$i18n.viewingWithActor,
                values: {
                    actorName: actingUserName
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6721937fde404080$var$i18n.viewing);
            const lastActive = agent.lastActive;
            const shouldShowLastActive = (0, $c6zRP.isAgentPresenceInactive)(agent) && lastActive !== undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, activityDescription, shouldShowLastActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "aria-hidden": "true"
            }, " \u2022 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oOTt.LastActive), {
                timestamp: lastActive
            })));
        };
        $[2] = actingUserName;
        $[3] = agent;
        $[4] = t2;
    } else t2 = $[4];
    const getPresenceDescription = t2;
    let t3;
    if ($[5] !== agent.id || $[6] !== handleAgentClick) {
        t3 = ()=>handleAgentClick(agent.id);
        $[5] = agent.id;
        $[6] = handleAgentClick;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== actingUserAvatarUrl || $[9] !== actingUserName || $[10] !== agent) {
        t4 = (0, $9wGTI.fg)("platform_move_presence_agents") ? actingUserName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fnCzB.DualAvatarWithIdentityCards), {
            agentName: agent.name,
            isOffsetInlineStart: false,
            stack: "default",
            agentAvatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
                agent: agent,
                size: "small",
                showBorder: true
            }),
            userName: actingUserName,
            userBorderColor: "var(--ds-surface-overlay, #FFFFFF)",
            userAvatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: actingUserAvatarUrl,
                name: actingUserName,
                size: "xxsmall",
                borderColor: "transparent",
                label: ""
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent,
            size: "small",
            showBorder: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent
        });
        $[8] = actingUserAvatarUrl;
        $[9] = actingUserName;
        $[10] = agent;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== getPresenceDescription) {
        t5 = getPresenceDescription();
        $[12] = getPresenceDescription;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== agent.name || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: t3,
            iconBefore: t4,
            description: t5
        }, agent.name);
        $[14] = agent.name;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
module.exports["AgentPresenceMenuItem"] = $6721937fde404080$export$e32187f91d1fd188;

});

parcelRegister("9oOTt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

'use no memo';
const $e5f17c20e6681c34$var$MINUTE_IN_MS = 60000;
const $e5f17c20e6681c34$var$HOUR_IN_MS = 60 * $e5f17c20e6681c34$var$MINUTE_IN_MS;
const $e5f17c20e6681c34$var$DAY_IN_MS = 24 * $e5f17c20e6681c34$var$HOUR_IN_MS;
const $e5f17c20e6681c34$var$getCompactRelativeTime = (timestamp)=>{
    const elapsed = Math.max(0, Date.now() - timestamp);
    if (elapsed < $e5f17c20e6681c34$var$HOUR_IN_MS) {
        const count = Math.max(1, Math.floor(elapsed / $e5f17c20e6681c34$var$MINUTE_IN_MS));
        return {
            count: count,
            unit: 'minute',
            updateAfter: Math.min((count + 1) * $e5f17c20e6681c34$var$MINUTE_IN_MS, $e5f17c20e6681c34$var$HOUR_IN_MS) - elapsed
        };
    }
    if (elapsed < $e5f17c20e6681c34$var$DAY_IN_MS) {
        const count = Math.floor(elapsed / $e5f17c20e6681c34$var$HOUR_IN_MS);
        return {
            count: count,
            unit: 'hour',
            updateAfter: Math.min((count + 1) * $e5f17c20e6681c34$var$HOUR_IN_MS, $e5f17c20e6681c34$var$DAY_IN_MS) - elapsed
        };
    }
    const count = Math.floor(elapsed / $e5f17c20e6681c34$var$DAY_IN_MS);
    return {
        count: count,
        unit: 'day',
        updateAfter: (count + 1) * $e5f17c20e6681c34$var$DAY_IN_MS - elapsed
    };
};
const $e5f17c20e6681c34$export$f2c78f0c61306fc2 = ({ timestamp: timestamp })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [, setRenders] = (0, $cozmU.useState)(0);
    const { count: count, unit: unit, updateAfter: updateAfter } = $e5f17c20e6681c34$var$getCompactRelativeTime(timestamp);
    (0, $cozmU.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setRenders((renders)=>renders + 1);
        }, updateAfter);
        return ()=>clearTimeout(timeout);
    }, [
        updateAfter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, intl.formatRelativeTime(-count, unit, {
        numeric: 'always',
        style: 'narrow'
    }));
};
module.exports["LastActive"] = $e5f17c20e6681c34$export$f2c78f0c61306fc2;

});

parcelRegister("gvTDP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $2yWJZ = parcelRequire("2yWJZ");


var $a4kze = parcelRequire("a4kze");


var $9wGTI = parcelRequire("9wGTI");


var $k9TfW = parcelRequire("k9TfW");

const $ddff92cdf55dc8ff$var$i18n = (0, $kSwu1.defineMessages)({
    externalAgentName: {
        id: "team-presence.external-agent.name",
        defaultMessage: "External agent"
    },
    rovoAgentName: {
        id: "team-presence.rovo-agent.name",
        defaultMessage: "Rovo"
    },
    claudeAgentName: {
        id: "team-presence.claude-agent.name",
        defaultMessage: "Claude"
    },
    codexAgentName: {
        id: "team-presence.codex-agent.name",
        defaultMessage: "Codex"
    },
    cursorAgentName: {
        id: "team-presence.cursor-agent.name",
        defaultMessage: "Cursor"
    },
    chatgptAgentName: {
        id: "team-presence.chatgpt-agent.name",
        defaultMessage: "ChatGPT"
    },
    diaAgentName: {
        id: "team-presence.dia-agent.name",
        defaultMessage: "Dia"
    },
    figmaAgentName: {
        id: "team-presence.figma-agent.name",
        defaultMessage: "Figma"
    },
    githubCopilotAgentName: {
        id: "team-presence.github-copilot-agent.name",
        defaultMessage: "GitHub Copilot"
    },
    grokAgentName: {
        id: "team-presence.grok-agent.name",
        defaultMessage: "Grok"
    },
    hermesAgentName: {
        id: "team-presence.hermes-agent.name",
        defaultMessage: "Hermes"
    },
    kiroAgentName: {
        id: "team-presence.kiro-agent.name",
        defaultMessage: "Kiro"
    },
    lovableAgentName: {
        id: "team-presence.lovable-agent.name",
        defaultMessage: "Lovable"
    },
    openCodeAgentName: {
        id: "team-presence.open-code-agent.name",
        defaultMessage: "Open Code"
    },
    replitAgentName: {
        id: "team-presence.replit-agent.name",
        defaultMessage: "Replit"
    },
    vscodeAgentName: {
        id: "team-presence.vscode-agent.name",
        defaultMessage: "Visual Studio Code"
    }
});
const $ddff92cdf55dc8ff$export$b1c286c6934f901d = ()=>{
    const $ = (0, $bDgLe.c)(51);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($ddff92cdf55dc8ff$var$i18n.chatgptAgentName);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage($ddff92cdf55dc8ff$var$i18n.claudeAgentName);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage($ddff92cdf55dc8ff$var$i18n.codexAgentName);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== formatMessage) {
        t3 = formatMessage($ddff92cdf55dc8ff$var$i18n.cursorAgentName);
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== formatMessage) {
        t4 = formatMessage($ddff92cdf55dc8ff$var$i18n.diaAgentName);
        $[8] = formatMessage;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== formatMessage) {
        t5 = formatMessage($ddff92cdf55dc8ff$var$i18n.figmaAgentName);
        $[10] = formatMessage;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== formatMessage) {
        t6 = formatMessage($ddff92cdf55dc8ff$var$i18n.githubCopilotAgentName);
        $[12] = formatMessage;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== formatMessage) {
        t7 = formatMessage($ddff92cdf55dc8ff$var$i18n.grokAgentName);
        $[14] = formatMessage;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== formatMessage) {
        t8 = formatMessage($ddff92cdf55dc8ff$var$i18n.hermesAgentName);
        $[16] = formatMessage;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== formatMessage) {
        t9 = formatMessage($ddff92cdf55dc8ff$var$i18n.kiroAgentName);
        $[18] = formatMessage;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== formatMessage) {
        t10 = formatMessage($ddff92cdf55dc8ff$var$i18n.lovableAgentName);
        $[20] = formatMessage;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== formatMessage) {
        t11 = formatMessage($ddff92cdf55dc8ff$var$i18n.openCodeAgentName);
        $[22] = formatMessage;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== formatMessage) {
        t12 = formatMessage($ddff92cdf55dc8ff$var$i18n.replitAgentName);
        $[24] = formatMessage;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== formatMessage) {
        t13 = formatMessage($ddff92cdf55dc8ff$var$i18n.rovoAgentName);
        $[26] = formatMessage;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== formatMessage) {
        t14 = formatMessage($ddff92cdf55dc8ff$var$i18n.vscodeAgentName);
        $[28] = formatMessage;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== t0 || $[31] !== t1 || $[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t2 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
        t15 = {
            chatgpt: t0,
            claude: t1,
            codex: t2,
            cursor: t3,
            dia: t4,
            figma: t5,
            github_copilot: t6,
            grok: t7,
            hermes: t8,
            kiro: t9,
            lovable: t10,
            open_code: t11,
            replit: t12,
            rovo: t13,
            vscode: t14
        };
        $[30] = t0;
        $[31] = t1;
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
        $[36] = t14;
        $[37] = t2;
        $[38] = t3;
        $[39] = t4;
        $[40] = t5;
        $[41] = t6;
        $[42] = t7;
        $[43] = t8;
        $[44] = t9;
        $[45] = t15;
    } else t15 = $[45];
    let t16;
    if ($[46] !== formatMessage) {
        t16 = formatMessage($ddff92cdf55dc8ff$var$i18n.externalAgentName);
        $[46] = formatMessage;
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== t15 || $[49] !== t16) {
        t17 = {
            agentNames: t15,
            fallbackAgentName: t16
        };
        $[48] = t15;
        $[49] = t16;
        $[50] = t17;
    } else t17 = $[50];
    return t17;
};
const $ddff92cdf55dc8ff$export$959584bf50f6069a = (cloudId)=>({
        siteId: cloudId,
        product: 'confluence',
        experienceId: 'ai-mate',
        touchpointSource: 'aiAgentPresence'
    });
const $ddff92cdf55dc8ff$var$createFallbackAgent = (agentId, name)=>({
        id: agentId,
        identity_account_id: null,
        named_id: agentId,
        name: name,
        description: null,
        creator_type: 'CUSTOMER',
        available_plugins: {},
        is_default: false,
        actor_type: 'AGENT',
        user_defined_conversation_starters: null,
        favourite: false,
        deactivated: false,
        isExternalAgentFallback: true
    });
const $ddff92cdf55dc8ff$var$hasConcreteAgentId = ({ agentId: agentId, agentType: agentType })=>Boolean(agentId) && agentId !== agentType;
const $ddff92cdf55dc8ff$var$createIdentityAgent = (identifier, user, fallbackAgentName)=>({
        ...$ddff92cdf55dc8ff$var$createFallbackAgent(identifier.agentId, fallbackAgentName),
        agentType: identifier.agentType,
        avatarUrl: user.avatar,
        id: identifier.agentId,
        identity_account_id: user.userId,
        isExternalAgentFallback: false,
        named_id: user.userId,
        name: user.name
    });
const $ddff92cdf55dc8ff$var$createTypedFallbackAgent = (identifier, fallbackAgentName, agentIcon)=>({
        ...$ddff92cdf55dc8ff$var$createFallbackAgent(identifier.agentId, fallbackAgentName),
        agentType: identifier.agentType,
        ...agentIcon ? {
            agentIcon: agentIcon
        } : {}
    });
const $ddff92cdf55dc8ff$var$createRovoChatAgent = (identifier, name)=>$ddff92cdf55dc8ff$var$createTypedFallbackAgent({
        ...identifier,
        agentId: 'rovo_chat'
    }, name, 'rovo');
const $ddff92cdf55dc8ff$var$resolveStudioAgent = async (identifier, assistanceService, fallbackAgentName, rovoAgentName)=>{
    if (!$ddff92cdf55dc8ff$var$hasConcreteAgentId(identifier)) return $ddff92cdf55dc8ff$var$createRovoChatAgent(identifier, rovoAgentName);
    try {
        const agent = await assistanceService.getAgentDetailsByIdentityAccountId(identifier.agentId);
        if ((0, $2yWJZ.isDefaultRovoChat)({
            agentId: agent.id,
            agentNamedId: agent.named_id
        })) return $ddff92cdf55dc8ff$var$createRovoChatAgent(identifier, rovoAgentName);
        const agentBrand = agent.creator_type === 'OOTB' ? (0, $a4kze.getAgentBrand)(agent.name.replace(/ Agent$/, '')) : undefined;
        return {
            ...agent,
            agentType: identifier.agentType,
            ...agentBrand && {
                agentIcon: agentBrand.agentIcon
            }
        };
    } catch  {
        return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
    }
};
const $ddff92cdf55dc8ff$var$resolveStudioAgentById = async (identifier, assistanceService, fallbackAgentName)=>{
    try {
        return {
            ...await assistanceService.getAgentDetails(identifier.agentId),
            agentType: identifier.agentType
        };
    } catch  {
        return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
    }
};
const $ddff92cdf55dc8ff$var$resolveIdentityAgent = async (identifier, identityUsersByIdPromise, fallbackAgentName)=>{
    const user = (await identityUsersByIdPromise).get(identifier.agentId);
    return user ? $ddff92cdf55dc8ff$var$createIdentityAgent(identifier, user, fallbackAgentName) : $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
};
const $ddff92cdf55dc8ff$var$resolveAgentIdentifier = (identifier, assistanceService, identityUsersByIdPromise, fallbackAgentName, agentNames)=>{
    switch(identifier.agentType){
        case 'claude':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.claude, 'claude');
        case 'codex':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.codex, 'codex');
        case 'cursor':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.cursor, 'cursor');
        case 'chatgpt':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.chatgpt, 'chatgpt');
        case 'dia':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.dia, 'dia');
        case 'figma':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.figma, 'figma');
        case 'lovable':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.lovable, 'lovable');
        case 'replit':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.replit, 'replit');
        case 'grok':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.grok, 'grok');
        case 'github_copilot':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.github_copilot, 'github-copilot');
        case 'vscode':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.vscode, 'vscode');
        case 'open_code':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.open_code, 'open-code');
        case 'hermes':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.hermes, 'hermes');
        case 'kiro':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, agentNames.kiro, 'kiro');
        case 'convo-ai':
            return $ddff92cdf55dc8ff$var$resolveStudioAgent(identifier, assistanceService, fallbackAgentName, agentNames.rovo);
        case 'mcp':
            return $ddff92cdf55dc8ff$var$resolveIdentityAgent(identifier, identityUsersByIdPromise, fallbackAgentName);
        case 'twg':
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
        case 'rovo_chat':
            return $ddff92cdf55dc8ff$var$createRovoChatAgent(identifier, agentNames.rovo);
        default:
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if (!(0, $9wGTI.fg)('platform_move_presence_agents') && identifier.agentType === undefined) return $ddff92cdf55dc8ff$var$resolveStudioAgentById(identifier, assistanceService, fallbackAgentName);
            return $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent');
    }
};
const $ddff92cdf55dc8ff$export$295d604d6e5465fc = (0, $lJ6db.createHookWithAssistanceService)(({ agentIdentifiers: agentIdentifiers, fallbackAgentName: fallbackAgentName, agentNames: agentNames, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { data: data } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentPresenceAgentsByIds',
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('confluence_agent_presence_profile_by_type') ? 'type-directed' : 'legacy',
            ...agentIdentifiers.map(({ agentId: agentId, agentType: agentType })=>`${agentType ?? ''}:${agentId}`).sort()
        ],
        queryFn: async ()=>{
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if (!(0, $9wGTI.fg)('confluence_agent_presence_profile_by_type')) {
                const entries = await Promise.all(agentIdentifiers.map(async (identifier)=>{
                    const { agentId: agentId } = identifier;
                    try {
                        return [
                            agentId,
                            await assistanceService.getAgentDetails(agentId)
                        ];
                    } catch  {
                        try {
                            return [
                                agentId,
                                await assistanceService.getAgentDetailsByIdentityAccountId(agentId)
                            ];
                        } catch  {
                            return [
                                agentId,
                                $ddff92cdf55dc8ff$var$createTypedFallbackAgent(identifier, fallbackAgentName, 'ai-agent')
                            ];
                        }
                    }
                }));
                return new Map(entries);
            }
            const identityAgentIds = agentIdentifiers.flatMap((identifier)=>$ddff92cdf55dc8ff$var$hasConcreteAgentId(identifier) && identifier.agentType === 'mcp' ? [
                    identifier.agentId
                ] : []);
            const identityUsersByIdPromise = identityAgentIds.length > 0 ? (0, $k9TfW.fetchPresenceAGGUsers)(identityAgentIds).then((users)=>new Map(users.map((user)=>[
                        user.userId,
                        user
                    ]))).catch(()=>new Map()) : Promise.resolve(new Map());
            return new Map(await Promise.all(agentIdentifiers.map(async (identifier)=>[
                    identifier.agentId,
                    await $ddff92cdf55dc8ff$var$resolveAgentIdentifier(identifier, assistanceService, identityUsersByIdPromise, fallbackAgentName, agentNames)
                ])));
        },
        enabled: agentIdentifiers.length > 0
    });
    return data ?? null;
});
module.exports["useAgentPresenceResolverMessages"] = $ddff92cdf55dc8ff$export$b1c286c6934f901d;
module.exports["buildAgentPresenceAssistanceServiceParams"] = $ddff92cdf55dc8ff$export$959584bf50f6069a;
module.exports["useAgentsByIdsWithAgentEdits"] = $ddff92cdf55dc8ff$export$295d604d6e5465fc;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = appearance === "default" && $7e44050607850249$var$styles.defaultAppearance;
    const t3 = appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance;
    const t4 = appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance;
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== target || $[13] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[12] = target;
        $[13] = testId;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== children || $[16] !== htmlAttributes || $[17] !== newWindowLabel || $[18] !== ref || $[19] !== t6 || $[20] !== t7 || $[21] !== target || $[22] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[15] = children;
        $[16] = htmlAttributes;
        $[17] = newWindowLabel;
        $[18] = ref;
        $[19] = t6;
        $[20] = t7;
        $[21] = target;
        $[22] = testId;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("aIOjp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4dGdo = parcelRequire("4dGdo");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $kUXcd = parcelRequire("kUXcd");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $638c8511a917505b$var$ShrinkOut = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, duration: t1, onFinish: onFinish } = t0;
    const duration = t1 === undefined ? "small" : t1;
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const exiting = (0, $kUXcd.useExitingPersistence)();
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    const setTimeout = (0, $1U6E9.useSetTimeout)();
    const direction = exiting.isExiting ? "exiting" : "entering";
    let t2;
    if ($[0] !== duration || $[1] !== element || $[2] !== exiting || $[3] !== onFinish || $[4] !== requestAnimationFrame || $[5] !== setTimeout) {
        t2 = ()=>{
            if (exiting.isExiting && element) {
                if ((0, $jlWUB.isReducedMotion)()) {
                    exiting.onFinish && exiting.onFinish();
                    onFinish && onFinish("exiting");
                    return;
                }
                const newStyles = {
                    width: `${element.offsetWidth}px`,
                    height: `${element.offsetHeight}px`,
                    boxSizing: "border-box",
                    willChange: "width,margin"
                };
                Object.assign(element.style, newStyles);
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const newStyles_0 = {
                            width: "0px",
                            margin: "0px",
                            transitionTimingFunction: "cubic-bezier(0.8,0,0,0.8)",
                            transitionDuration: (0, $4dGdo.durations)[duration] + "ms",
                            transitionProperty: "width,margin"
                        };
                        Object.assign(element.style, newStyles_0);
                        setTimeout(()=>{
                            exiting.onFinish && exiting.onFinish();
                            onFinish && onFinish("exiting");
                        }, (0, $4dGdo.durations)[duration]);
                    });
                });
            }
        };
        $[0] = duration;
        $[1] = element;
        $[2] = exiting;
        $[3] = onFinish;
        $[4] = requestAnimationFrame;
        $[5] = setTimeout;
        $[6] = t2;
    } else t2 = $[6];
    (0, $7BVQi.useLayoutEffect)(t2);
    let t3;
    if ($[7] !== children || $[8] !== direction || $[9] !== setElementRef) {
        t3 = children({
            ref: setElementRef
        }, direction);
        $[7] = children;
        $[8] = direction;
        $[9] = setElementRef;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const exiting = (0, $kUXcd.useExitingPersistence)();
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    const setTimeout = (0, $1U6E9.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $jlWUB.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles_0 = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4dGdo.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles_0);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4dGdo.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $638c8511a917505b$export$2e2bcd8739ae039 = $638c8511a917505b$var$ShrinkOut;
module.exports["default"] = $638c8511a917505b$export$2e2bcd8739ae039;

});

parcelRegister("8OcYi", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $bw5Pv = parcelRequire("bw5Pv");


var $kAdyG = parcelRequire("kAdyG");

const $133fea730ff32cc6$var$extractEntityEmbedUrl = (response)=>{
    const entity = (0, $8YE7G.extractEntity)(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $133fea730ff32cc6$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $133fea730ff32cc6$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $bw5Pv.extractPreview)(response?.data, 'web', iframeUrlType);
};
module.exports["extractSmartLinkEmbed"] = $133fea730ff32cc6$export$864b719baf5d744d;

});

parcelRegister("bw5Pv", function(module, exports) {

var $bnAp5 = parcelRequire("bnAp5");


var $1kPn4 = parcelRequire("1kPn4");

const $ba88b61fea6ab33b$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $bnAp5.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $1kPn4.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $1kPn4.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
module.exports["extractPreview"] = $ba88b61fea6ab33b$export$4b0d98b1b7f6d115;

});

parcelRegister("bnAp5", function(module, exports) {
const $8a5fa431dcdb46ea$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
module.exports["extractPlatformIsSupported"] = $8a5fa431dcdb46ea$export$3e8ad908070b68b2;

});

parcelRegister("jMcHR", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $04c77007239bb1c9$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $1kPn4.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $04c77007239bb1c9$export$63f54cf4c5883620;

});

parcelRegister("de3yk", function(module, exports) {
const $aef0eb130344f15c$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};
module.exports["getUrl"] = $aef0eb130344f15c$export$94df0e59ebebf4a7;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("ipkS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $3GQl6 = parcelRequire("3GQl6");

const $689b0be44fd5c2f8$var$logger = (0, $7W8i8.getLogger)('trackReactLazy');
// Marks a subtree whose code only loads when a render-time lazy component renders. The client
// cannot load it before hydration, so lazy components inside it must not hold hydration.
const $689b0be44fd5c2f8$var$RenderTimeLazyAncestor = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $689b0be44fd5c2f8$var$warnedRenderTimeIds = new Set();
// React 18's lazy initializer checks the component's status as soon as `then` returns, and suspends
// unless `then` has already called back. `Promise.resolve(loaded)` always calls back in a
// microtask, so it would suspend even for a loaded module. This Promise overrides `then` to call
// back synchronously. The rest of the Promise API goes through `then`, so `catch`, `finally` and
// `Promise.all` still work.
const $689b0be44fd5c2f8$var$resolvedThenable = (value)=>{
    const promise = new Promise((resolve)=>resolve(value));
    promise.then = (onFulfilled)=>Promise.resolve(onFulfilled ? onFulfilled(value) : value);
    return promise;
};
function $689b0be44fd5c2f8$var$withServerTracking(id, module, { renderTime: renderTime, source: source }) {
    const Original = module.default;
    const TrackedLazy = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        const hasRenderTimeAncestor = (0, $cozmU.useContext)($689b0be44fd5c2f8$var$RenderTimeLazyAncestor);
        const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Original, {
            ...props,
            ref: ref
        });
        if (renderTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689b0be44fd5c2f8$var$RenderTimeLazyAncestor.Provider, {
            value: true
        }, element);
        // Effects do not run during SSR, so render is the only place to record the rendered split.
        if (!hasRenderTimeAncestor && (0, $6mKj3.expValEquals)('confluence_ssr_react_lazy_preload', 'isEnabled', true)) (0, $3GQl6.addLoadableId)(id);
        return element;
    });
    TrackedLazy.displayName = `TrackedLazy(${Original.displayName || Original.name || 'Component'})`;
    return {
        ...module,
        default: TrackedLazy
    };
}
function $689b0be44fd5c2f8$export$fb5c897fe5d03fec(id, loader, options = {}) {
    // process.env.REACT_SSR is read inline so each build can drop the other side's branch. None of
    // these branches changes rendered markup, so they cannot cause a hydration mismatch.
    const prepare = (module)=>module;
    if (options.renderTime) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return loader;
    let loaded;
    let pending;
    const load = ()=>{
        pending ?? (pending = loader().then((module)=>{
            loaded = prepare(module);
            return loaded;
        }, (error)=>{
            pending = undefined;
            throw error;
        }));
        return pending;
    };
    let preloaded = false;
    // preloadIfNeeded can start loading at once. Waiting a microtask lets the defining module
    // finish evaluating before the loader reads any of its bindings.
    (0, $3GQl6.preloadIfNeeded)(id, undefined, ()=>Promise.resolve().then(load).then(()=>{
            preloaded = true;
        }));
    return ()=>{
        if (!loaded) return load();
        // The client only answers synchronously after the preload the server asked for, so lazy
        // components behave as before when the experiment is off.
        const canResolveSynchronously = preloaded;
        return canResolveSynchronously ? $689b0be44fd5c2f8$var$resolvedThenable(loaded) : load();
    };
}
module.exports["trackReactLazy"] = $689b0be44fd5c2f8$export$fb5c897fe5d03fec;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("2JKQ0", function(module, exports) {
const $88abaf6247c4a414$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $88abaf6247c4a414$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
module.exports["defaultLogoParams"] = $88abaf6247c4a414$export$438460117ae6b7ee;
module.exports["legacyDefaultLogoParams"] = $88abaf6247c4a414$export$793fba32aed8942a;

});

parcelRegister("ihy5X", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $063b37f584f47387$var$CSS_VAR_COLOR = '--logo-color';
const $063b37f584f47387$var$CSS_VAR_FILL = '--logo-fill';
const $063b37f584f47387$var$styles = {
    root: "_3iDTPbvbI6 _1mT5xdRAKS _1UtDYzlyLl _1rdFvh4YQS _26BoRw7dHp _20VacPYbGa _1ANEUSzUZr _2kxbLJN91d _0fvd5AOLYo",
    stop: "_24fbFs98eZ",
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $063b37f584f47387$var$Wrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let appearance;
    let iconColor;
    let label;
    let rest;
    let size;
    let svg;
    let textColor;
    let userDefinedTestId;
    if ($[0] !== t0) {
        ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = iconColor;
        $[3] = label;
        $[4] = rest;
        $[5] = size;
        $[6] = svg;
        $[7] = textColor;
        $[8] = userDefinedTestId;
    } else {
        appearance = $[1];
        iconColor = $[2];
        label = $[3];
        rest = $[4];
        size = $[5];
        svg = $[6];
        textColor = $[7];
        userDefinedTestId = $[8];
    }
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    let t1;
    if ($[9] !== iconColor || $[10] !== textColor) {
        t1 = {
            [$063b37f584f47387$var$CSS_VAR_COLOR]: iconColor,
            [$063b37f584f47387$var$CSS_VAR_FILL]: textColor
        };
        $[9] = iconColor;
        $[10] = textColor;
        $[11] = t1;
    } else t1 = $[11];
    const t2 = t1;
    const t3 = label ? label : undefined;
    const t4 = label ? "img" : undefined;
    let t5;
    if ($[12] !== svg) {
        t5 = {
            __html: svg
        };
        $[12] = svg;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = shouldApplyStopColor && $063b37f584f47387$var$styles.stop;
    const t7 = size && $063b37f584f47387$var$styles[size];
    let t8;
    if ($[14] !== t6 || $[15] !== t7) {
        t8 = (0, $hekY6.default)([
            $063b37f584f47387$var$styles.root,
            t6,
            t7
        ]);
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== rest || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t8 || $[23] !== testId) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t2,
            "aria-label": t3,
            role: t4,
            dangerouslySetInnerHTML: t5,
            ...rest,
            className: t8
        });
        $[17] = rest;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t8;
        $[23] = testId;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            [$063b37f584f47387$var$CSS_VAR_COLOR]: iconColor,
            [$063b37f584f47387$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $hekY6.default)([
            $063b37f584f47387$var$styles.root,
            shouldApplyStopColor && $063b37f584f47387$var$styles.stop,
            size && $063b37f584f47387$var$styles[size]
        ])
    });
};
var $063b37f584f47387$export$2e2bcd8739ae039 = $063b37f584f47387$var$Wrapper;
module.exports["default"] = $063b37f584f47387$export$2e2bcd8739ae039;

});

parcelRegister("kejsE", function(module, exports) {
const $f7c26c357aa6be32$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
module.exports["getColorsFromAppearance"] = $f7c26c357aa6be32$export$bbacc3980e0f3029;

});

parcelRegister("NlHoa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $441e7b8270821bd5$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $441e7b8270821bd5$export$8a485e2e7ed91e8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, iconColor: t3, textColor: t4, testId: testId } = t0;
    const label = t1 === undefined ? "Atlassian" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $441e7b8270821bd5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            testId: testId
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $2JKQ0.defaultLogoParams).size, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $441e7b8270821bd5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};
module.exports["AtlassianIcon"] = $441e7b8270821bd5$export$8a485e2e7ed91e8f;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("ddpUU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $dGDOF = parcelRequire("dGDOF");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $arQY7 = parcelRequire("arQY7");


var $7ijRz = parcelRequire("7ijRz");

const $d3eacc68e490612e$export$4bc8bcb977dc5ae2 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ userFragment: userFragment, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, presence: presence, size: size, status: status, stackIndex: stackIndex, tabIndex: tabIndex, target: target, onClick: onClick, testId: testId, analyticsContext: analyticsContext, as: as, imgLoading: imgLoading, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const user = (0, $6SsN4.useFragment)((0, $dGDOF.default), userFragment);
    const appearance = (0, $7ijRz.getAppearanceForAppType)(user?.appType);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        ref: ref,
        // from relay fragment
        src: user?.picture,
        appearance: appearance,
        // prop-drill from AvatarRelayProps
        label: label,
        borderColor: borderColor,
        children: children,
        href: href,
        isDisabled: isDisabled,
        name: name,
        presence: presence,
        size: size,
        status: status,
        stackIndex: stackIndex,
        tabIndex: tabIndex,
        target: target,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        as: as,
        imgLoading: imgLoading,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup
    });
});
module.exports["AvatarRelay"] = $d3eacc68e490612e$export$4bc8bcb977dc5ae2;

});

parcelRegister("dGDOF", function(module, exports) {
/**
 * @generated SignedSource<<fc353150c45a4f7c6c9094cc1a2d8fa6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8fca1aa8bb1206a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "avatarRelay_user",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appType"
                }
            ],
            "type": "AppUser"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
$8fca1aa8bb1206a9$var$node.hash = "507292d34580d58c48df1e1edacc7bad";
var $8fca1aa8bb1206a9$export$2e2bcd8739ae039 = $8fca1aa8bb1206a9$var$node;
module.exports["default"] = $8fca1aa8bb1206a9$export$2e2bcd8739ae039;

});

parcelRegister("7ijRz", function(module, exports) {
function $820425378f796737$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'team':
            // @TODO investigate if team comes from appType or if it is a separate way to detect
            return 'square';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}
module.exports["getAppearanceForAppType"] = $820425378f796737$export$6b45b5bd2259198a;

});

parcelRegister("b3j2Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

function $ff81fbcf85bdaf85$export$d56b0569bceb92ae(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, error: error } = t0;
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== error) {
        t1 = ()=>{
            const listener = (event)=>{
                if (event.error === error) event.preventDefault();
            };
            window.addEventListener("error", listener);
            setErrorListenerIsReady(true);
            return ()=>{
                window.removeEventListener("error", listener);
                setErrorListenerIsReady(false);
            };
        };
        t2 = [
            error,
            setErrorListenerIsReady
        ];
        $[0] = error;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    const renderOnError = t3;
    let t4;
    if ($[5] !== error || $[6] !== errorListenerIsReady) {
        t4 = errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
            error: error
        }) : null;
        $[5] = error;
        $[6] = errorListenerIsReady;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== renderOnError || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INHERIT,
            renderOnError: renderOnError
        }, t4);
        $[8] = renderOnError;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}
module.exports["ErrorDisplay"] = $ff81fbcf85bdaf85$export$d56b0569bceb92ae;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("hvS6g", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");

const $e332deabb876ffbc$export$c3136e12f209350a = (0, $3u0dr.isReactCompilerActiveV2)() ? function RelaySuspense(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { children: children, fallback: fallback, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== children || $[1] !== fallback || $[2] !== interactionName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: fallback,
            interactionName: interactionName
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = interactionName;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function RelaySuspense({ children: children, fallback: fallback, interactionName: interactionName }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: fallback,
        interactionName: interactionName
    }, children);
};
module.exports["RelaySuspense"] = $e332deabb876ffbc$export$c3136e12f209350a;

});


//# sourceMappingURL=AgentPresence.02e241a2.js.map
